module.exports = __webpack_public_path__ + "img/logo_carquefou.cf077925.png";